import { render, staticRenderFns } from "./GiftshopSelectionModalProductVariants.vue?vue&type=template&id=267b9cbc&"
import script from "./GiftshopSelectionModalProductVariants.vue?vue&type=script&lang=ts&"
export * from "./GiftshopSelectionModalProductVariants.vue?vue&type=script&lang=ts&"
import style0 from "./GiftshopSelectionModalProductVariants.vue?vue&type=style&index=0&id=267b9cbc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports